import { inferRouteObject } from 'react-router-typed-object';
import z from 'zod';

import { Navigate } from '@/js/libs/router';
import { PrivateRoute, Roles, or } from '@/js/libs/use-auth';

import { forecastRouterSearchParamsSchema } from 'src/scenes/Orders/containers/Forecast/constants.ts';
import Orders from 'src/scenes/Orders/index.ts';
import Status from 'src/scenes/Status/index.ts';
import { PositionHistorySearchKey } from 'src/types.ts';

export const orders2RouteObject = inferRouteObject({
  path: 'orders',
  element: (
    <PrivateRoute
      roles={or(Roles.ADMIN, Roles.SELF_BOOKING, Roles.BOOK_CAMPAIGNS, Roles.POSTNETZ_BRANCH_USER, Roles.READ_ONLY_POSTNETZ_BRANCH_USER)}
      noAccessComponent={Status.NotFound}
    />
  ),
  children: [
    {
      Component: Orders.Helmet,
      children: [
        {
          Component: Orders.PositionHistory.Providers,
          children: [
            {
              path: 'campaign/:campaignId/position-history/:positionId?',
              Component: Orders.PositionHistory.Component,
              searchParams: z.object({
                [PositionHistorySearchKey.BACK_TO]: z.string().optional(),
              }).parse,
            },
          ],
        },
        {
          element: <PrivateRoute roles={Roles.MANAGE_DIGITAL_PRODUCTS} noAccessComponent={Status.NotFound} />,
          children: [
            {
              path: 'forecast',
              Component: Orders.Forecast,
              searchParams: forecastRouterSearchParamsSchema.parse,
            },
          ],
        },
        {
          path: 'booking',
          Component: Orders.Booking,
        },
        {
          // The report moved to its own top-level section (#23477); the tab it sat on is gone, but the
          // addresses it was bookmarked and linked under are kept alive - the deals tab's among them, which
          // is what the QA suite drives. No guard of its own: whoever cannot reach the destination gets the
          // destination's own not-found page.
          path: 'programmatic-deals',
          children: [
            { index: true, element: <Navigate to='/programmatic-deals/reporting' replace /> },
            { path: '*', element: <Navigate to='/programmatic-deals/reporting' replace /> },
          ],
        },
      ],
    },
  ],
});
